import { registerLayout, unRegisterLayout, getLayoutByName } from "./registy";
// register layout
export { registerLayout, unRegisterLayout, getLayoutByName };
// layout, layout types file, worker
export * from "./layout";
//# sourceMappingURL=index.js.map